module.exports = __webpack_public_path__ + "static/code-aac8372b285ada069aee8dbe1c5fcfaa.png";